<div class="row g-3">
  <div class="col-12">
    <div class="card shadow border-0" id="quick-stats">
      <div class="card-header fw-bold">
        <h6 class="card-title mb-0"><i class="bi bi-bar-chart-fill"></i> Quick Stats: Last 7 Days</h6>
      </div>

      <div class="card-body">
        <div class="row text-center">
          <div class="col-6 col-lg-3">
            <p class="text-muted fw-bold mb-0">CLICKS</p>
            <div class="h5 p-3 bg-light-pink rounded">
              <i class="bi bi-mouse-fill me-2"></i>{{ globalHomeStat.week.clicks }}
            </div>
          </div>

          <div class="col-6 col-lg-3">
            <p class="text-muted fw-bold mb-0">CONVERSIONS</p>
            <div class="h5 p-3 bg-light-pink rounded">
              <i class="bi bi-check-circle-fill me-2"></i>{{ globalHomeStat.week.conversions }}
            </div>
          </div>

          <div class="col-6 col-lg-3">
            <p class="text-muted fw-bold mb-0">PAYOUT</p>
            <div class="h5 p-3 bg-light-pink rounded">
              <i class="bi bi-cash-stack me-2"></i>{{ globalHomeStat.week.revenue | money:2:$safeNavigationMigration(globalHomeStat.week.currency?.isoCode) }}
            </div>
          </div>

          <div class="col-6 col-lg-3">
            <p class="text-muted fw-bold mb-0">PAYOUT ({{ currentYear }} YTD)</p>
            <div class="h5 p-3 bg-light-pink rounded">
              <i class="bi bi-bar-chart-fill me-2"></i>{{ globalHomeStat.ytd.revenue | money:2:$safeNavigationMigration(globalHomeStat.ytd.currency?.isoCode) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xxl-6">
    <div class="card shadow border-0 h-100">
      <div class="card-header d-flex align-items-center justify-content-between"><h6 class="card-title mb-0"><i
      class="bi bi-megaphone-fill"></i> What's New</h6>
      <!-- Boutons carousel mobile -->
      @if (mobileNews.length > 1) {
        <div class="d-flex d-lg-none align-items-center">
          <button class="carousel-control-prev text-secondary me-2" type="button" data-bs-target="#news-carousel-mobile"
            data-bs-slide="prev">Previous
          </button>
          <button class="carousel-control-next text-secondary" type="button" data-bs-target="#news-carousel-mobile"
            data-bs-slide="next">Next
          </button>
        </div>
      }

      <!-- Boutons carousel desktop -->
      @if (desktopNews.length > 3) {
        <div class="d-none d-lg-flex align-items-center">
          <button class="carousel-control-prev text-secondary me-2" type="button" data-bs-target="#news-carousel"
            data-bs-slide="prev">Previous
          </button>
          <button class="carousel-control-next text-secondary" type="button" data-bs-target="#news-carousel"
            data-bs-slide="next">Next
          </button>
        </div>
      }
    </div>

    <div class="card-body">
      <!-- Carousel mobile :1 news par slide -->
      <div id="news-carousel-mobile" class="carousel slide d-block d-lg-none" data-bs-ride="carousel">
        <div class="carousel-inner">
          @for (singleNews of mobileNews; track singleNews; let i = $index) {
            <div [class.active]="i === 0" class="carousel-item">
              <div class="news-item align-items-center">
                <img [src]="imageService.getImageUrl(singleNews.image)" class="img-fluid rounded me-3" alt="News Image">
                <div>
                  <p class="text-muted mb-1"><small>📅 {{ singleNews.publishedAt | date:'dd MMM yyyy' }}</small></p>
                  <h6 class="mb-0">{{ singleNews.title }}</h6>
                  <p class="text-muted mb-2">{{ singleNews.excerpt }}</p>
                  <button (click)="openNews(singleNews)" class="btn btn-primary btn-sm fw-bold">Learn more...</button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Carousel desktop : 3 news par slide -->
      <div id="news-carousel" class="carousel slide d-none d-lg-block" data-bs-ride="carousel">
        <div class="carousel-inner">
          @for (newsGroup of desktopNews; track newsGroup; let i = $index) {
            <div [class.active]="i === 0" class="carousel-item">
              @for (singleNews of newsGroup; track singleNews) {
                <div class="news-item d-flex align-items-center mb-3">
                  <img [src]="imageService.getImageUrl(singleNews.image)" class="img-fluid rounded me-3" alt="News Image">
                  <div>
                    <p class="text-muted mb-1"><small>📅 {{ singleNews.publishedAt | date:'dd MMM yyyy' }}</small></p>
                    <h6 class="mb-0">{{ singleNews.title }}</h6>
                    <p class="text-muted mb-2">{{ singleNews.excerpt }}</p>
                    <button (click)="openNews(singleNews)" class="btn btn-primary btn-sm fw-bold">Learn more...</button>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="col-xxl-6">
  <div class="card shadow border-0 h-100">
    <div class="card-header">
      <h6 class="card-title mb-0"><i class="bi bi-speedometer2"></i> Global Performance</h6>
    </div>

    <div class="card-body">
      <div class="row mb-3">
        <div class="col-6">
          <div class="bg-light-pink p-3 rounded mb-2">
            <h5 class="mb-0">
              <i class="bi bi-cash-coin me-2"></i>{{ globalHomeStat.mtd.revenue | money:2:$safeNavigationMigration(globalHomeStat.mtd.currency?.isoCode) }}<strong class="ms-2">MTD</strong></h5>
            </div>
          </div>
          <div class="col-6">
            <div class="bg-light-pink p-3 rounded mb-2">
              <h5 class="mb-0">
                <i class="bi bi-cash-coin me-2"></i>{{ globalHomeStat.ytd.revenue | money:2:$safeNavigationMigration(globalHomeStat.ytd.currency?.isoCode) }}<strong class="ms-2">YTD</strong>
              </h5>
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-hover mb-0">
            <thead class="table-light">
              <tr>
                <th>Timeframe</th>
                <th>Clics</th>
                <th>Conversions</th>
                <th>CR (%)</th>
                <th>EPC</th>
                <th>Revenue</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Today - {{ getTodayDate() | date : 'dd/MM/yyyy' }}</td>
                <td>{{ globalHomeStat.today.clicks }}</td>
                <td>{{ globalHomeStat.today.conversions }}</td>
                <td>{{ globalHomeStat.today.conversionRate | percent }}</td>
                <td>{{ globalHomeStat.today.epc | money:2:$safeNavigationMigration(globalHomeStat.today.currency?.isoCode) }}</td>
                <td>{{ globalHomeStat.today.revenue | money:2:$safeNavigationMigration(globalHomeStat.today.currency?.isoCode) }}</td>
              </tr>
              <tr>
                <td>WTD</td>
                <td>{{ globalHomeStat.wtd.clicks }}</td>
                <td>{{ globalHomeStat.wtd.conversions }}</td>
                <td>{{ globalHomeStat.wtd.conversionRate | percent }}</td>
                <td>{{ globalHomeStat.wtd.epc | money:2:$safeNavigationMigration(globalHomeStat.wtd.currency?.isoCode) }}</td>
                <td>{{ globalHomeStat.wtd.revenue | money:2:$safeNavigationMigration(globalHomeStat.wtd.currency?.isoCode) }}</td>
              </tr>
              <tr>
                <td>7-Day</td>
                <td>{{ globalHomeStat.week.clicks }}</td>
                <td>{{ globalHomeStat.week.conversions }}</td>
                <td>{{ globalHomeStat.week.conversionRate | percent }}</td>
                <td>{{ globalHomeStat.week.epc | money:2:$safeNavigationMigration(globalHomeStat.week.currency?.isoCode) }}</td>
                <td>{{ globalHomeStat.week.revenue | money:2:$safeNavigationMigration(globalHomeStat.week.currency?.isoCode) }}</td>
              </tr>
              <tr>
                <td>MTD</td>
                <td>{{ globalHomeStat.mtd.clicks }}</td>
                <td>{{ globalHomeStat.mtd.conversions }}</td>
                <td>{{ globalHomeStat.mtd.conversionRate | percent }}</td>
                <td>{{ globalHomeStat.mtd.epc | money:2:$safeNavigationMigration(globalHomeStat.mtd.currency?.isoCode) }}</td>
                <td>{{ globalHomeStat.mtd.revenue | money:2:$safeNavigationMigration(globalHomeStat.mtd.currency?.isoCode) }}</td>
              </tr>
              <tr>
                <td>30-Day</td>
                <td>{{ globalHomeStat.month.clicks }}</td>
                <td>{{ globalHomeStat.month.conversions }}</td>
                <td>{{ globalHomeStat.month.conversionRate | percent }}</td>
                <td>{{ globalHomeStat.month.epc | money:2:$safeNavigationMigration(globalHomeStat.month.currency?.isoCode) }}</td>
                <td>{{ globalHomeStat.month.revenue | money:2:$safeNavigationMigration(globalHomeStat.month.currency?.isoCode) }}</td>
              </tr>
              <tr>
                <td>12 Months</td>
                <td>{{ globalHomeStat.year.clicks }}</td>
                <td>{{ globalHomeStat.year.conversions }}</td>
                <td>{{ globalHomeStat.year.conversionRate | percent }}</td>
                <td>{{ globalHomeStat.year.epc | money:2:$safeNavigationMigration(globalHomeStat.year.currency?.isoCode) }}</td>
                <td>{{ globalHomeStat.year.revenue | money:2:$safeNavigationMigration(globalHomeStat.year.currency?.isoCode) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xxl-6">
    <div class="card shadow border-0 h-100">
      <div class="card-header">
        <h6 class="card-title mb-0"><i class="bi bi-award-fill"></i> Top Offers</h6>
      </div>

      <div class="card-body">
        <form [formGroup]="topOffersFilter">
          <div class="row">
            <div class="col-6">
              <select (change)="fetchTopOffers()" formControlName="country" class="form-select form-select-sm mb-3" id="country">
                <option [ngValue]="null">🌍 All countries</option>

                @for (country of countries; track country) {
                  <option [value]="country.isoCode">{{ country.flagEmoji }} {{ country }}</option>
                }
              </select>
            </div>

            <div class="col-6">
              <select (change)="fetchTopOffers()" formControlName="date" class="form-select form-select-sm mb-3" id="date">
                <option value="today">Today</option>
                <option value="week">Week</option>
                <option value="month">Month</option>
                <option value="year">Year</option>
              </select>
            </div>
          </div>
        </form>

        <div class="table-responsive">
          <table class="table table-hover table-striped">
            <thead class="table-light">
              <tr>
                <th>#</th>
                <th>Offer Name</th>
                <th>Geos</th>
                <th>Payout Mode</th>
                <th>Payout</th>
                <th>Custom payout</th>
                <th>EPC</th>
              </tr>
            </thead>
            <tbody>
              @for (topOffer of topOffers; track topOffer; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ topOffer.offer?.name ?? '' }}</td>
                  <td>
                    @if (topOffer.offer) {
                      @if (!expandedCountries[i]) {
                        @for (country of topOffer.offer.countries.slice(0, 5) ?? []; track country) {
                          <span>
                            {{ topOffer.offer.getCountryEmoji(country) }}
                          </span>
                        }
                        @if (topOffer.offer.countries.length > 5) {
                          <span class="text-muted" role="button"
                          (click)="expandedCountries[i] = true">...({{ topOffer.offer.countries.length }})</span>
                        }
                      }
                      @if (expandedCountries[i]) {
                        @for (country of topOffer.offer.countries ?? []; track country) {
                          <span>
                            {{ topOffer.offer.getCountryEmoji(country) }}
                          </span>
                        }
                        <i (click)="expandedCountries[i] = false" class="bi bi-eye-slash-fill ms-1 text-muted" role="button"></i>
                      }
                    }
                  </td>
                  <td>
                    @if (topOffer.offer?.conversionType) {
                      <span>{{ ('conversionType.' + $safeNavigationMigration(topOffer.offer?.conversionType)) | translate }}</span>
                    }
                  </td>
                  <td>{{ (topOffer.offer?.payout ?? 0) | currency:2:$safeNavigationMigration(topOffer.offer?.currency?.isoCode) }}</td>
                  <td>
                    @if (topOffer.customPayout; as customPayout) {
                      @if (customPayout.payoutAmount !== null) {
                        <span
                        class="fw-bold">{{ customPayout.payoutAmount | currency:2:$safeNavigationMigration(customPayout.currency?.isoCode) }}</span>
                      }
                      @if (customPayout.payoutAmount === null && customPayout.payoutPercent !== null) {
                        <span
                        class="fw-bold">{{ customPayout.payoutPercent }} %</span>
                      }
                    }
                  </td>
                  <td>{{ (topOffer.epc ?? 0) | money:2:$safeNavigationMigration(topOffer.offer?.currency?.isoCode) }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

</div>
